import request from '../request.js'
// 修改/保存（张卫华）
const saveOrUpdate = function (data) {
    return request({
        url: 'sysRoleLimitTenant/saveOrUpdate',
        method: 'post',
        data
    })
}

export {
    saveOrUpdate,
}